module.exports = __webpack_public_path__ + "static/media/overlay8.ebeb4b49.png";